import { CommonModule } from '@angular/common';
import { Component, Input, ViewChild, ViewContainerRef } from '@angular/core';

@Component({
    selector: 'icon-pending-document',
    standalone: true,
    imports: [CommonModule],
    template: `
        <ng-template #template>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" [ngClass]="class">
                <path
                    opacity="0.5"
                    d="M0.75 8.75C0.75 4.97876 0.75 3.09315 1.92157 1.92157C3.09315 0.75 4.97876 0.75 8.75 0.75H10.75C14.5212 0.75 16.4069 0.75 17.5784 1.92157C18.75 3.09315 18.75 4.97876 18.75 8.75V12.75C18.75 16.5212 18.75 18.4069 17.5784 19.5784C16.4069 20.75 14.5212 20.75 10.75 20.75H8.75C4.97876 20.75 3.09315 20.75 1.92157 19.5784C0.75 18.4069 0.75 16.5212 0.75 12.75V8.75Z"
                    stroke="currentColor"
                    stroke-width="1.5"
                />
                <path d="M5.75 10.75H13.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                <path d="M5.75 6.75H13.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                <path d="M5.75 14.75H10.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                <circle cx="18.25" cy="18.25" r="4.5" fill="#D9D9D9" stroke="currentColor" />
                <path
                    d="M17.75 16.75V18.4167L18.7917 19.4583"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </ng-template>
    `,
})
export class IconPendingDocumentComponent {
    @Input() class: any = '';
    @ViewChild('template', { static: true }) template: any;
    constructor(private viewContainerRef: ViewContainerRef) {}
    ngOnInit() {
        this.viewContainerRef.createEmbeddedView(this.template);
        this.viewContainerRef.element.nativeElement.remove();
    }
}
